import { User, UserWarningStatus } from '~/api-definition/definition'
import { SexType, UserAlcoholAmountType } from '~/api-definition/enumTypes'
import { config } from '~/config'

export const userAttributesLabel = (
  user: User,
  opts?: { omitParen?: true }
): string => {
  const l = [
    user.showAge ? user.age : null,
    user.showSex && user.sex != 'not_known' ? userSexLabel(user.sex) : null,
    user.showRegion ? user.region?.regionName : null,
  ]
    .filter(Boolean)
    .join('・')
  if (opts?.omitParen) {
    return l
  } else {
    if (l.length === 0) {
      return ''
    } else {
      return `（${l}）`
    }
  }
}

export const userSexLabel = (sex: SexType): string => {
  switch (sex) {
    case 'male':
      return '男性'
    case 'female':
      return '女性'
    case 'not_known':
      return '指定なし'
    case 'not_applicable':
      return 'その他'
  }
}

export const userAlcoholAmountTypeLabel = (
  alcoholAmountType: UserAlcoholAmountType
): string => {
  switch (alcoholAmountType) {
    case 'unselected':
      return '未選択'
    case 'not_at_all':
      return '全く飲めない'
    case 'little':
      return '少しだけ飲める（例：グラス1,2杯）'
    case 'normal':
      return 'ほどほどに飲める（例：ワインボトル1本程度）'
    case 'large':
      return 'たくさん飲める'
    case 'depending_on_the_day':
      return '日によって異なる'
  }
}

export const userProfileIcon = (user: { profileIcon: User['profileIcon'] }) => {
  return {
    try: user.profileIcon?.imageUrl,
    fallback: config.noImageUrl.userProfileIcon,
  }
}

export const userProfileIconOpt = (
  user: { profileIcon: User['profileIcon'] } | undefined
) => {
  return {
    try: user?.profileIcon?.imageUrl,
    fallback: config.noImageUrl.userProfileIcon,
  }
}

export const userWarningStatusLabel = (
  userWarningStatus: UserWarningStatus
) => {
  switch (userWarningStatus.warningStatusType) {
    case 'low':
      return '要注意'
    case 'high':
      return '要警戒'
  }
}

export const userWarningStatusColor = (
  userWarningStatus: UserWarningStatus
) => {
  switch (userWarningStatus.warningStatusType) {
    case 'low':
      return '#FFD600'
    case 'high':
      return '#DF001A'
  }
}
